module.exports = __webpack_public_path__ + "media/flags/hk-803006af.svg";